import { useStaticQuery, graphql } from 'gatsby';

export const useFooterMenuData = () => {
  const { allMenuLinkContentCityspringsComFooter } = useStaticQuery(
    graphql`
      query MyQuery {
        allMenuLinkContentCityspringsComFooter(
          filter: {
            menu_name: {eq: "citysprings-com-footer"},
            enabled: {eq: true}
          }
        ) {
          nodes {
            id
            link {
              uri
            }
            title
          }
        }
      }
    `
  );

  const menuItems = allMenuLinkContentCityspringsComFooter.nodes.map(item => ({
    id: item.id,
    name: item.title,
    uri: item.link.uri,
  }));

  return menuItems;
};
